import ResultPage from './ResultPage';

export default ResultPage;
